export const getBaseUrl = () => global.config.dadata_url.replace(/\/*$/, '');
